/* eslint-disable */
import React from 'react';
import { useContext, useState, useEffect } from 'react';
import { MainContext } from '../../../context/ApiContext';
import { Nav, NavbarForm } from './styles';
import { DateTime } from 'luxon';
import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import useApp from '../../../hooks/useApp';
import useSWR from 'swr';
import { fetcher } from '../../../service/SWRFetcher';
import filterStyles from '../../filterStyles';
import { Box, Button, Grid } from '@material-ui/core';

const DatePeriodFilter = ({ userId, filters, setFilters }) => {
  const classes = filterStyles();
  const [brokerId, setBrokerId] = useState();
  const [technicalTeam, setTechnicalTeam] = useState();

  const { getters } = useContext(MainContext);
  const { technical_teams, brokers: users } = useApp();

  // const { data: users } = useSWR(`/users`, fetcher, { revalidateOnFocus: false });

  const [dates, setDates] = useState({
    date_ini: DateTime.now().plus({ months: -1 }).toISODate(),
    date_end: DateTime.now().toISODate(),
  });

  function handleSubmit(event, getters) {
    event.preventDefault();

    let filters = {
      date_ini: event.target.elements[0].value,
      date_end: event.target.elements[1].value,
      broker_id: brokerId?.map((b) => b.id) || "",
      technical_team: technicalTeam || "",
      paginate: "",
    };
    setFilters(filters);
  }

  useEffect(() => {
    console.log(filters);
  }, [filters]);

  return (
    <Box className={classes.boxFilter}>
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <Grid container spacing={2} alignItems="center">
          <Grid container item xs={12} md={12} alignItems="center" spacing={2}>
            <Grid item>
              <TextField
                className={classes.inputDate}
                type="date"
                name="date_ini"
                placeholder="Data Inicial"
                value={dates.date_ini}
                onChange={(e) => setDates(e)}
              />
            </Grid>

            <Grid item>
              <TextField
                className={classes.inputDate}
                type="date"
                name="date_end"
                placeholder="Data Final"
                value={dates.date_end}
                onChange={(e) => setDates(e)}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <Autocomplete
                className={classes.inputSelect}
                multiple
                options={users || []}
                getOptionLabel={(option) => option?.name}
                onChange={(e, value) => setBrokerId(value)}
                renderInput={(params) => (
                  <TextField {...params} className="autocomplete" variant="standard" placeholder="Corretor" />
                )}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <Autocomplete
                className={classes.inputSelect}
                options={technical_teams || []}
                getOptionLabel={(option) => option?.description}
                onChange={(e, value) => setTechnicalTeam(value)}
                renderInput={(params) => (
                  <TextField {...params} className="autocomplete" variant="standard" placeholder="Equipe" />
                )}
              />
            </Grid>

            <Grid item>
              <Button fullWidth className={classes.button} type="submit">
                Filtrar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default DatePeriodFilter;
